const STAGE_TO_BEHAVIORS = {
    'import': ['populate'],
    'form-recognition': ['populate'],
    'batch-fix': ['display'],
    'ocr': ['populate'],
    'post-ocr': ['populate', 'transform', 'substitute', 'parse'],
    // Lane C Part 2 — 'validate' is no longer a behavior (validation is derived
    // + authored on the Rules tab), so it is not pickable on any stage.
    'key-entry': ['populate', 'transform', 'compute', 'substitute', 'display'],
    'verification': ['display', 'parse'],
    'qa': ['display'],
    'supervisor': ['display'],
    'pre-export': ['transform', 'substitute', 'compute', 'parse', 'webhook'],
    'export': ['emit'],
};
export function validBehaviorsForStage(stage) {
    return STAGE_TO_BEHAVIORS[stage] ?? [];
}
/**
 * R-194 (re-opened) — derive the set of stages where a field has a
 * lifecycle ROLE, independent of whether an operator BEHAVIOR is
 * configured there.
 *
 * The Fields-tab StageStrip dots historically lit only when a behavior
 * existed (`stageMap[stage].length > 0`), so a field that OCR populates
 * but has no configured behavior showed a dead/unlit OCR dot. This helper
 * surfaces the lifecycle truth the operator expects:
 *
 *   - `ocr`:    the field participates in OCR extraction. As of R-123
 *               (2026-05-23) per-field OCR config MOVED to the OCR Profiles
 *               tab, so the modern signal is `ocrExtracted === true` OR a
 *               non-empty `ocrAliases[]`. The legacy `ocrFieldMapping`
 *               column is NO LONGER POPULATED for OCR-Profiles-configured
 *               fields, so it is intentionally IGNORED here — deriving the
 *               role from it produced uniformly dead dots even on
 *               OCR-populated fields (the bug this finding re-opens).
 *   - `import`: the field is stamped from a batch header on upload — true
 *               iff `headerMapping.paths[internalName]` is set.
 *   - `form-recognition` is whole-document classification with no per-field
 *     role, so it is NEVER returned here.
 *
 * Pure: no I/O, no store access — callers thread the field's modern OCR
 * signals + the Job Type's `headerMapping` in.
 *
 * @param field.ocrFieldMapping
 *   @deprecated Legacy column. NOT read for role derivation (R-123/R-194).
 *   It is accepted in the param type ONLY so callers that spread a full
 *   field object (which still carries this property) don't trip a TS
 *   excess-property error. It is intentionally IGNORED — the `ocr` role is
 *   derived from `ocrExtracted` / `ocrAliases` alone. Do not reintroduce it
 *   into the role logic: doing so reproduces the dead-dot bug R-194 closed.
 */
export function deriveStageRoles(field, headerMapping) {
    const roles = new Set();
    if (field.ocrExtracted === true || (field.ocrAliases?.length ?? 0) > 0) {
        roles.add('ocr');
    }
    const name = field.internalName;
    if (name && headerMapping?.paths && headerMapping.paths[name]) {
        roles.add('import');
    }
    return roles;
}
//# sourceMappingURL=stages.js.map